import React from 'react';

const StylesRadioImage = props => {
  const {
    src,
    htmlFor,
    labelClassName,
    radioName,
    radioClassName,
    alt,
    onChange,
    value,
    checked,
  } = props;

  return (
    <div className="bg-image-itm">
      <label htmlFor={htmlFor} className={labelClassName}>
        <img src={src} alt={alt} />
        <input
          type="radio"
          name={radioName}
          value={value}
          className={radioClassName}
          id={htmlFor}
          onChange={onChange}
          checked={checked}
        />
      </label>
    </div>
  );
};

export default StylesRadioImage;



// WEBPACK FOOTER //
// ./src/components/StylesRadioImage/StylesRadioImage.js